import memoizeOne from "memoize-one";
import { IStore } from "reducers";
import { IState as IMerchantPurchaseOrderDoorGroupState } from "reducers/merchant-purchase-order-door-group";

export const getMerchantPurchaseOrderDoorGroupState = (state: IStore): IMerchantPurchaseOrderDoorGroupState => {
    return state.merchantPurchaseOrderDoorGroup;
};

export const getMerchantPurchaseOrderDoorGroupList = (state: IStore) => {
    return getMerchantPurchaseOrderDoorGroupState(state).list.result;
};

const filterActiveMerchantPurchaseOrderDoorGroups = memoizeOne((merchantPurchaseOrderDoorGroups) => {
    return merchantPurchaseOrderDoorGroups.filter(
        (merchantPurchaseOrderDoorGroup) => merchantPurchaseOrderDoorGroup.active
    );
});
export const getActiveMerchantPurchaseOrderDoorGroups = (state: IStore) => {
    return filterActiveMerchantPurchaseOrderDoorGroups(getMerchantPurchaseOrderDoorGroupList(state));
};
